// @ts-ignore

export const BASE_PATH =
  process.env.REACT_APP_BASE_PATH || "https://test.gadderapp.com/";
export const TOKEN_LOCAL_KEY = "user_token";
export const TOKEN_PREFIX = "Bearer ";
